<template>
  <div class="launcher" v-if="app != null && app.data != null">
    <div class="settings" id="settings-content">
      <div @click="app.displaySettings()" id="boule" class="new-boule">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="30"
          viewBox="0 -960 960 960"
          width="30"
          style="fill: rgb(255, 255, 255)"
        >
          <path
            d="M130.001-254.616V-300h699.998v45.384H130.001Zm0-202.692v-45.384h699.998v45.384H130.001Zm0-202.692v-45.384h699.998V-660H130.001Z"
          />
        </svg>
      </div>
      <div id="settings-selector">
        <img class="line" id="line" src="line.png" />
        <div @click="app.closeSettings()" id="close-settings">
          <img src="arrows/white-cross.png" />
        </div>
        <div id="buttons">
          <button @click="app.refreshPage">Page d'accueil</button>
          <button @click="app.displayIndisponible()">Jeux</button>
          <button @click="app.displayRules()">Règles</button>
          <button @click="app.displayAbout(false)">A propos</button>
          <blockquote id="indisponible" style="display: none">
            Indisponible pour le moment
          </blockquote>
        </div>
      </div>
    </div>

    <about v-bind:app="app"></about>
    <rules v-bind:app="app"></rules>
  </div>
</template>

<script>
import about from "./about.vue";
import rules from "./rules.vue";

export default {
  name: "SettingsVue",
  props: {
    app: Object,
  },
  components: {
    about,
    rules,
  },
};
</script>
